import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";

import { BillingContext } from "../Context";
import useAvailableSelfServicePlan from "./useAvailableSelfServicePlan";

const useAvailableAddons = () => {
  const { availableBillingAddons } = useTypedContext(BillingContext);
  const tier = useAvailableSelfServicePlan()?.tier;

  return useMemo(() => {
    if (!tier) return [];

    return availableBillingAddons
      .filter((addon) => addon.tiers.includes(tier))
      .map((addon) => ({
        ...addon,
        monthlyPrice: addon.monthlyPrice / 100,
        yearlyPrice: addon.yearlyPrice / 100,
      }));
  }, [availableBillingAddons, tier]);
};

export default useAvailableAddons;
